/* global axios */
import ApiClient from './ApiClient';

class ReportSchedulesAPI extends ApiClient {
  constructor() {
    super('report_schedules', { accountScoped: true });
  }

  // Upsert by (report_key, frequency) on the backend, so create doubles as update.
  upsert(schedule) {
    return axios.post(this.url, { report_schedule: schedule });
  }

  updateById(id, schedule) {
    return axios.patch(`${this.url}/${id}`, { report_schedule: schedule });
  }

  // Downloads the static sample CSV for a report as a blob.
  downloadSample(reportKey) {
    return axios.get(`${this.url}/sample`, {
      params: { report_key: reportKey },
      responseType: 'blob',
    });
  }
}

export default new ReportSchedulesAPI();
